// extracted by mini-css-extract-plugin
export default {"mapWrapper":"WorldMap_mapWrapper__mzbIL","mapContainer":"WorldMap_mapContainer__0FwLO","zoom":"WorldMap_zoom__l7a8D","resetBtn":"WorldMap_resetBtn__4k51e"};